import React from 'react';
import PropTypes from 'prop-types';

const ViewDateTime = ({ data, skipTime }) => {

  let datestring = "";

  if ((data) && (data !== null) && (typeof data.getMonth === 'function')) {
    let day = data.getDate().toString();
    if (data.getDate() < 10) {
      day = "0" + data.getDate().toString();
    }
    let month = (data.getMonth() + 1).toString();
    if (data.getMonth() + 1 < 10) {
      month = "0" + (data.getMonth() + 1).toString();
    }

    if (skipTime) {
      datestring = day + "." + month + "." + data.getFullYear();
    }
    else
    {
      let hours = data.getHours().toString();
      if (data.getHours() < 10) {
        hours = "0" + data.getHours().toString();
      }
      let minutes = data.getMinutes().toString();
      if (data.getMinutes() < 10) {
        minutes = "0" + data.getMinutes().toString();
      }
      datestring = day + "." + month + "." + data.getFullYear() + " " + hours +  ":" + minutes;
    }

  }
  return (
    <span>{datestring}</span>
  );
};

ViewDateTime.propTypes = {
  data: PropTypes.object,
  skipTime : PropTypes.bool
};

export default ViewDateTime;



// WEBPACK FOOTER //
// ./src/components/Display/ViewDateTime.js